// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import * as bootstrap from "bootstrap";

const confirmMethod = (message, _element) => {
  let dialog = document.getElementById("turbo-confirm");
  dialog.querySelector("p").textContent = message;
  dialog.showModal();

  return new Promise((resolve, _reject) => {
    dialog.addEventListener(
      "close",
      () => {
        resolve(dialog.returnValue === "confirm");
      },
      { once: true },
    );
  });
};
Turbo.config.forms.confirm = confirmMethod;

window.bootstrap = bootstrap;
